import "././phone.scss"
import "./custom.scss";
import React, { useState, useRef,Fragment, useEffect } from "react";
import HelperService from "../../Services/HelperService";
// import { BiChevronDown } from "../../react-icons/bi";
// import { FloatingLabel, Form } from "../../../react-bootstrap";
// import useClickOutside from "../../hook/UseClickOutSide";
import useClickOutside from "../hook/UseClickOutSide";



// import Call from "../../assets/images/call.svg";
// export interface Options {
//     id: any;
//     code?: string;
//     value: string;
//     value2?: string;
//     parentCode?: string;
//     object?: any;
//     icon?: string;
// }

interface PropData {
    selected: any;
    onChange: any;
    onChangeCode: any;
    value: any;
    isDisable?: boolean;
    isDisableInput?: boolean;
    onBlur?: any;
    onChangeCountryCode?: any
    placeholder?: any
}


const allCountries = [
    {
        "id": 1,
        "uuid": "82e95eae-9853-11ec-9985-f2fb1e710544",
        "name": "Afghanistan",
        "country_code": "AF",
        "phone_code": "+93",
        "image": "af",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 2,
        "uuid": "82e95f8c-9853-11ec-9985-f2fb1e710544",
        "name": "Aland Islands",
        "country_code": "AX",
        "phone_code": "+358",
        "image": "ax",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 3,
        "uuid": "82e95fed-9853-11ec-9985-f2fb1e710544",
        "name": "Albania",
        "country_code": "AL",
        "phone_code": "+355",
        "image": "al",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 4,
        "uuid": "82e96049-9853-11ec-9985-f2fb1e710544",
        "name": "Algeria",
        "country_code": "DZ",
        "phone_code": "+213",
        "image": "dz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 5,
        "uuid": "82e960a3-9853-11ec-9985-f2fb1e710544",
        "name": "American Samoa",
        "country_code": "AS",
        "phone_code": "+1684",
        "image": "as",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 6,
        "uuid": "82e9610a-9853-11ec-9985-f2fb1e710544",
        "name": "Andorra",
        "country_code": "AD",
        "phone_code": "+376",
        "image": "ad",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 7,
        "uuid": "82e96187-9853-11ec-9985-f2fb1e710544",
        "name": "Angola",
        "country_code": "AO",
        "phone_code": "+244",
        "image": "ao",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 8,
        "uuid": "82e961e1-9853-11ec-9985-f2fb1e710544",
        "name": "Anguilla",
        "country_code": "AI",
        "phone_code": "+1264",
        "image": "ai",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 9,
        "uuid": "82e9623b-9853-11ec-9985-f2fb1e710544",
        "name": "Antarctica",
        "country_code": "AQ",
        "phone_code": "0",
        "image": "aq",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 10,
        "uuid": "82e96293-9853-11ec-9985-f2fb1e710544",
        "name": "Antigua and Barbuda",
        "country_code": "AG",
        "phone_code": "+1268",
        "image": "ag",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 11,
        "uuid": "82e962ec-9853-11ec-9985-f2fb1e710544",
        "name": "Argentina",
        "country_code": "AR",
        "phone_code": "+54",
        "image": "ar",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 12,
        "uuid": "82e96346-9853-11ec-9985-f2fb1e710544",
        "name": "Armenia",
        "country_code": "AM",
        "phone_code": "+374",
        "image": "am",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 13,
        "uuid": "82e9639e-9853-11ec-9985-f2fb1e710544",
        "name": "Aruba",
        "country_code": "AW",
        "phone_code": "+297",
        "image": "aw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 14,
        "uuid": "82e963f5-9853-11ec-9985-f2fb1e710544",
        "name": "Australia",
        "country_code": "AU",
        "phone_code": "+61",
        "image": "au",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 15,
        "uuid": "82e9644d-9853-11ec-9985-f2fb1e710544",
        "name": "Austria",
        "country_code": "AT",
        "phone_code": "+43",
        "image": "at",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 16,
        "uuid": "82e964a6-9853-11ec-9985-f2fb1e710544",
        "name": "Azerbaijan",
        "country_code": "AZ",
        "phone_code": "+994",
        "image": "az",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 17,
        "uuid": "82e964fd-9853-11ec-9985-f2fb1e710544",
        "name": "Bahamas",
        "country_code": "BS",
        "phone_code": "+1242",
        "image": "bs",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 18,
        "uuid": "82e96555-9853-11ec-9985-f2fb1e710544",
        "name": "Bahrain",
        "country_code": "BH",
        "phone_code": "+973",
        "image": "bh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 19,
        "uuid": "82e965ac-9853-11ec-9985-f2fb1e710544",
        "name": "Bangladesh",
        "country_code": "BD",
        "phone_code": "+880",
        "image": "bd",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 20,
        "uuid": "82e96603-9853-11ec-9985-f2fb1e710544",
        "name": "Barbados",
        "country_code": "BB",
        "phone_code": "+1246",
        "image": "bb",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 21,
        "uuid": "82e96659-9853-11ec-9985-f2fb1e710544",
        "name": "Belarus",
        "country_code": "BY",
        "phone_code": "+375",
        "image": "by",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 22,
        "uuid": "82e966b2-9853-11ec-9985-f2fb1e710544",
        "name": "Belgium",
        "country_code": "BE",
        "phone_code": "+32",
        "image": "be",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 23,
        "uuid": "82e96709-9853-11ec-9985-f2fb1e710544",
        "name": "Belize",
        "country_code": "BZ",
        "phone_code": "+501",
        "image": "bz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 24,
        "uuid": "82e96760-9853-11ec-9985-f2fb1e710544",
        "name": "Benin",
        "country_code": "BJ",
        "phone_code": "+229",
        "image": "bj",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 25,
        "uuid": "82e967b7-9853-11ec-9985-f2fb1e710544",
        "name": "Bermuda",
        "country_code": "BM",
        "phone_code": "+1441",
        "image": "bm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 26,
        "uuid": "82e9680e-9853-11ec-9985-f2fb1e710544",
        "name": "Bhutan",
        "country_code": "BT",
        "phone_code": "+975",
        "image": "bt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 27,
        "uuid": "82e96865-9853-11ec-9985-f2fb1e710544",
        "name": "Bolivia",
        "country_code": "BO",
        "phone_code": "+591",
        "image": "bo",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 28,
        "uuid": "82e968bd-9853-11ec-9985-f2fb1e710544",
        "name": "Bonaire, Sint Eustatius and Saba",
        "country_code": "BQ",
        "phone_code": "+599",
        "image": "bq",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 29,
        "uuid": "82e96916-9853-11ec-9985-f2fb1e710544",
        "name": "Bosnia and Herzegovina",
        "country_code": "BA",
        "phone_code": "+387",
        "image": "ba",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 30,
        "uuid": "82e9696d-9853-11ec-9985-f2fb1e710544",
        "name": "Botswana",
        "country_code": "BW",
        "phone_code": "+267",
        "image": "bw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 31,
        "uuid": "82e969c4-9853-11ec-9985-f2fb1e710544",
        "name": "Bouvet Island",
        "country_code": "BV",
        "phone_code": "0",
        "image": "bv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 32,
        "uuid": "82e96a1b-9853-11ec-9985-f2fb1e710544",
        "name": "Brazil",
        "country_code": "BR",
        "phone_code": "+55",
        "image": "br",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 33,
        "uuid": "82e96a72-9853-11ec-9985-f2fb1e710544",
        "name": "British Indian Ocean Territory",
        "country_code": "IO",
        "phone_code": "+246",
        "image": "io",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 34,
        "uuid": "82e96b00-9853-11ec-9985-f2fb1e710544",
        "name": "Brunei Darussalam",
        "country_code": "BN",
        "phone_code": "+673",
        "image": "bn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 35,
        "uuid": "82e96b59-9853-11ec-9985-f2fb1e710544",
        "name": "Bulgaria",
        "country_code": "BG",
        "phone_code": "+359",
        "image": "bg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 36,
        "uuid": "82e96bb0-9853-11ec-9985-f2fb1e710544",
        "name": "Burkina Faso",
        "country_code": "BF",
        "phone_code": "+226",
        "image": "bf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 37,
        "uuid": "82e96c07-9853-11ec-9985-f2fb1e710544",
        "name": "Burundi",
        "country_code": "BI",
        "phone_code": "+257",
        "image": "bi",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 38,
        "uuid": "82e96c5e-9853-11ec-9985-f2fb1e710544",
        "name": "Cambodia",
        "country_code": "KH",
        "phone_code": "+855",
        "image": "kh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 39,
        "uuid": "82e96cb4-9853-11ec-9985-f2fb1e710544",
        "name": "Cameroon",
        "country_code": "CM",
        "phone_code": "+237",
        "image": "cm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 40,
        "uuid": "82e96d0b-9853-11ec-9985-f2fb1e710544",
        "name": "Canada",
        "country_code": "CA",
        "phone_code": "+1",
        "image": "ca",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 41,
        "uuid": "82e96d62-9853-11ec-9985-f2fb1e710544",
        "name": "Cape Verde",
        "country_code": "CV",
        "phone_code": "+238",
        "image": "cv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 42,
        "uuid": "82e96db9-9853-11ec-9985-f2fb1e710544",
        "name": "Cayman Islands",
        "country_code": "KY",
        "phone_code": "+1345",
        "image": "ky",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 43,
        "uuid": "82e96e10-9853-11ec-9985-f2fb1e710544",
        "name": "Central African Republic",
        "country_code": "CF",
        "phone_code": "+236",
        "image": "cf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 44,
        "uuid": "82e96e67-9853-11ec-9985-f2fb1e710544",
        "name": "Chad",
        "country_code": "TD",
        "phone_code": "+235",
        "image": "td",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 45,
        "uuid": "82e96ebf-9853-11ec-9985-f2fb1e710544",
        "name": "Chile",
        "country_code": "CL",
        "phone_code": "+56",
        "image": "cl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 46,
        "uuid": "82e96f16-9853-11ec-9985-f2fb1e710544",
        "name": "China",
        "country_code": "CN",
        "phone_code": "+86",
        "image": "cn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 47,
        "uuid": "82e96f6d-9853-11ec-9985-f2fb1e710544",
        "name": "Christmas Island",
        "country_code": "CX",
        "phone_code": "+61",
        "image": "cx",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 48,
        "uuid": "82e96fc4-9853-11ec-9985-f2fb1e710544",
        "name": "Cocos (Keeling) Islands",
        "country_code": "CC",
        "phone_code": "+672",
        "image": "cc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 49,
        "uuid": "82e970e4-9853-11ec-9985-f2fb1e710544",
        "name": "Colombia",
        "country_code": "CO",
        "phone_code": "+57",
        "image": "co",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 50,
        "uuid": "82e9713e-9853-11ec-9985-f2fb1e710544",
        "name": "Comoros",
        "country_code": "KM",
        "phone_code": "+269",
        "image": "km",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 51,
        "uuid": "82e97195-9853-11ec-9985-f2fb1e710544",
        "name": "Congo",
        "country_code": "CG",
        "phone_code": "+243",
        "image": "cg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 52,
        "uuid": "82e971ed-9853-11ec-9985-f2fb1e710544",
        "name": "Congo, Democratic Republic of the Congo",
        "country_code": "CD",
        "phone_code": "+242",
        "image": "cd",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 53,
        "uuid": "82e97244-9853-11ec-9985-f2fb1e710544",
        "name": "Cook Islands",
        "country_code": "CK",
        "phone_code": "+682",
        "image": "ck",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 54,
        "uuid": "82e9729b-9853-11ec-9985-f2fb1e710544",
        "name": "Costa Rica",
        "country_code": "CR",
        "phone_code": "+506",
        "image": "cr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 55,
        "uuid": "82e972f2-9853-11ec-9985-f2fb1e710544",
        "name": "Cote D`Ivoire",
        "country_code": "CI",
        "phone_code": "+225",
        "image": "ci",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 56,
        "uuid": "82e97349-9853-11ec-9985-f2fb1e710544",
        "name": "Croatia",
        "country_code": "HR",
        "phone_code": "+385",
        "image": "hr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 57,
        "uuid": "82e9739f-9853-11ec-9985-f2fb1e710544",
        "name": "Cuba",
        "country_code": "CU",
        "phone_code": "+53",
        "image": "cu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 58,
        "uuid": "82e973f7-9853-11ec-9985-f2fb1e710544",
        "name": "Curacao",
        "country_code": "CW",
        "phone_code": "+599",
        "image": "cw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 59,
        "uuid": "82e9744e-9853-11ec-9985-f2fb1e710544",
        "name": "Cyprus",
        "country_code": "CY",
        "phone_code": "+357",
        "image": "cy",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 60,
        "uuid": "82e974a5-9853-11ec-9985-f2fb1e710544",
        "name": "Czech Republic",
        "country_code": "CZ",
        "phone_code": "+420",
        "image": "cz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 61,
        "uuid": "82e974fc-9853-11ec-9985-f2fb1e710544",
        "name": "Denmark",
        "country_code": "DK",
        "phone_code": "+45",
        "image": "dk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 62,
        "uuid": "82e97553-9853-11ec-9985-f2fb1e710544",
        "name": "Djibouti",
        "country_code": "DJ",
        "phone_code": "+253",
        "image": "dj",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 63,
        "uuid": "82e975aa-9853-11ec-9985-f2fb1e710544",
        "name": "Dominica",
        "country_code": "DM",
        "phone_code": "+1767",
        "image": "dm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 64,
        "uuid": "82e97601-9853-11ec-9985-f2fb1e710544",
        "name": "Dominican Republic",
        "country_code": "DO",
        "phone_code": "+1809",
        "image": "do",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 65,
        "uuid": "82e97659-9853-11ec-9985-f2fb1e710544",
        "name": "Ecuador",
        "country_code": "EC",
        "phone_code": "+593",
        "image": "ec",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 66,
        "uuid": "82e976b0-9853-11ec-9985-f2fb1e710544",
        "name": "Egypt",
        "country_code": "EG",
        "phone_code": "+20",
        "image": "eg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 67,
        "uuid": "82e97707-9853-11ec-9985-f2fb1e710544",
        "name": "El Salvador",
        "country_code": "SV",
        "phone_code": "+503",
        "image": "sv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 68,
        "uuid": "82e9775e-9853-11ec-9985-f2fb1e710544",
        "name": "Equatorial Guinea",
        "country_code": "GQ",
        "phone_code": "+240",
        "image": "gq",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 69,
        "uuid": "82e977b5-9853-11ec-9985-f2fb1e710544",
        "name": "Eritrea",
        "country_code": "ER",
        "phone_code": "+291",
        "image": "er",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 70,
        "uuid": "82e9780c-9853-11ec-9985-f2fb1e710544",
        "name": "Estonia",
        "country_code": "EE",
        "phone_code": "+372",
        "image": "ee",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 71,
        "uuid": "82e978c5-9853-11ec-9985-f2fb1e710544",
        "name": "Ethiopia",
        "country_code": "ET",
        "phone_code": "+251",
        "image": "et",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 72,
        "uuid": "82e9795d-9853-11ec-9985-f2fb1e710544",
        "name": "Falkland Islands (Malvinas)",
        "country_code": "FK",
        "phone_code": "+500",
        "image": "fk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 73,
        "uuid": "82e979e8-9853-11ec-9985-f2fb1e710544",
        "name": "Faroe Islands",
        "country_code": "FO",
        "phone_code": "+298",
        "image": "fo",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 74,
        "uuid": "82e97a56-9853-11ec-9985-f2fb1e710544",
        "name": "Fiji",
        "country_code": "FJ",
        "phone_code": "+679",
        "image": "fj",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 75,
        "uuid": "82e97aaf-9853-11ec-9985-f2fb1e710544",
        "name": "Finland",
        "country_code": "FI",
        "phone_code": "+358",
        "image": "fi",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 76,
        "uuid": "82e97b07-9853-11ec-9985-f2fb1e710544",
        "name": "France",
        "country_code": "FR",
        "phone_code": "+33",
        "image": "fr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 77,
        "uuid": "82e97b5e-9853-11ec-9985-f2fb1e710544",
        "name": "French Guiana",
        "country_code": "GF",
        "phone_code": "+594",
        "image": "gf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 78,
        "uuid": "82e97bb6-9853-11ec-9985-f2fb1e710544",
        "name": "French Polynesia",
        "country_code": "PF",
        "phone_code": "+689",
        "image": "pf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 79,
        "uuid": "82e97c0d-9853-11ec-9985-f2fb1e710544",
        "name": "French Southern Territories",
        "country_code": "TF",
        "phone_code": "0",
        "image": "tf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 80,
        "uuid": "82e97c64-9853-11ec-9985-f2fb1e710544",
        "name": "Gabon",
        "country_code": "GA",
        "phone_code": "+241",
        "image": "ga",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 81,
        "uuid": "82e97cbc-9853-11ec-9985-f2fb1e710544",
        "name": "Gambia",
        "country_code": "GM",
        "phone_code": "+220",
        "image": "gm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 82,
        "uuid": "82e97d13-9853-11ec-9985-f2fb1e710544",
        "name": "Georgia",
        "country_code": "GE",
        "phone_code": "+995",
        "image": "ge",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 83,
        "uuid": "82e97d6a-9853-11ec-9985-f2fb1e710544",
        "name": "Germany",
        "country_code": "DE",
        "phone_code": "+49",
        "image": "de",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 84,
        "uuid": "82e97dc1-9853-11ec-9985-f2fb1e710544",
        "name": "Ghana",
        "country_code": "GH",
        "phone_code": "+233",
        "image": "gh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 85,
        "uuid": "82e97e17-9853-11ec-9985-f2fb1e710544",
        "name": "Gibraltar",
        "country_code": "GI",
        "phone_code": "+350",
        "image": "gi",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 86,
        "uuid": "82e97e6e-9853-11ec-9985-f2fb1e710544",
        "name": "Greece",
        "country_code": "GR",
        "phone_code": "+30",
        "image": "gr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 87,
        "uuid": "82e97ec4-9853-11ec-9985-f2fb1e710544",
        "name": "Greenland",
        "country_code": "GL",
        "phone_code": "+299",
        "image": "gl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 88,
        "uuid": "82e97f1a-9853-11ec-9985-f2fb1e710544",
        "name": "Grenada",
        "country_code": "GD",
        "phone_code": "+1473",
        "image": "gd",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 89,
        "uuid": "82e97f71-9853-11ec-9985-f2fb1e710544",
        "name": "Guadeloupe",
        "country_code": "GP",
        "phone_code": "+590",
        "image": "gp",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 90,
        "uuid": "82e97fc8-9853-11ec-9985-f2fb1e710544",
        "name": "Guam",
        "country_code": "GU",
        "phone_code": "+1671",
        "image": "gu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 91,
        "uuid": "82e9801e-9853-11ec-9985-f2fb1e710544",
        "name": "Guatemala",
        "country_code": "GT",
        "phone_code": "+502",
        "image": "gt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 92,
        "uuid": "82e98074-9853-11ec-9985-f2fb1e710544",
        "name": "Guernsey",
        "country_code": "GG",
        "phone_code": "+44",
        "image": "gg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 93,
        "uuid": "82e980cb-9853-11ec-9985-f2fb1e710544",
        "name": "Guinea",
        "country_code": "GN",
        "phone_code": "+224",
        "image": "gn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 94,
        "uuid": "82e98121-9853-11ec-9985-f2fb1e710544",
        "name": "Guinea-Bissau",
        "country_code": "GW",
        "phone_code": "+245",
        "image": "gw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 95,
        "uuid": "82e98178-9853-11ec-9985-f2fb1e710544",
        "name": "Guyana",
        "country_code": "GY",
        "phone_code": "+592",
        "image": "gy",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 96,
        "uuid": "82e981ce-9853-11ec-9985-f2fb1e710544",
        "name": "Haiti",
        "country_code": "HT",
        "phone_code": "+509",
        "image": "ht",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 97,
        "uuid": "82e98224-9853-11ec-9985-f2fb1e710544",
        "name": "Heard Island and Mcdonald Islands",
        "country_code": "HM",
        "phone_code": "0",
        "image": "hm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 98,
        "uuid": "82e9827d-9853-11ec-9985-f2fb1e710544",
        "name": "Holy See (Vatican City State)",
        "country_code": "VA",
        "phone_code": "+379",
        "image": "va",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 99,
        "uuid": "82e982da-9853-11ec-9985-f2fb1e710544",
        "name": "Honduras",
        "country_code": "HN",
        "phone_code": "+504",
        "image": "hn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 100,
        "uuid": "82e98332-9853-11ec-9985-f2fb1e710544",
        "name": "Hong Kong",
        "country_code": "HK",
        "phone_code": "+852",
        "image": "hk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 101,
        "uuid": "82e98389-9853-11ec-9985-f2fb1e710544",
        "name": "Hungary",
        "country_code": "HU",
        "phone_code": "+36",
        "image": "hu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 102,
        "uuid": "82e983e1-9853-11ec-9985-f2fb1e710544",
        "name": "Iceland",
        "country_code": "IS",
        "phone_code": "+354",
        "image": "is",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 103,
        "uuid": "82e98438-9853-11ec-9985-f2fb1e710544",
        "name": "India",
        "country_code": "IN",
        "phone_code": "+91",
        "image": "in",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 104,
        "uuid": "82e98490-9853-11ec-9985-f2fb1e710544",
        "name": "Indonesia",
        "country_code": "ID",
        "phone_code": "+62",
        "image": "id",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 105,
        "uuid": "82e984ef-9853-11ec-9985-f2fb1e710544",
        "name": "Iran, Islamic Republic of",
        "country_code": "IR",
        "phone_code": "+98",
        "image": "ir",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 106,
        "uuid": "82e98547-9853-11ec-9985-f2fb1e710544",
        "name": "Iraq",
        "country_code": "IQ",
        "phone_code": "+964",
        "image": "iq",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 107,
        "uuid": "82e9859d-9853-11ec-9985-f2fb1e710544",
        "name": "Ireland",
        "country_code": "IE",
        "phone_code": "+353",
        "image": "ie",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 108,
        "uuid": "82e985f4-9853-11ec-9985-f2fb1e710544",
        "name": "Isle of Man",
        "country_code": "IM",
        "phone_code": "+44",
        "image": "im",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 109,
        "uuid": "82e9864a-9853-11ec-9985-f2fb1e710544",
        "name": "Israel",
        "country_code": "IL",
        "phone_code": "+972",
        "image": "il",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 110,
        "uuid": "82e986a1-9853-11ec-9985-f2fb1e710544",
        "name": "Italy",
        "country_code": "IT",
        "phone_code": "+39",
        "image": "it",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 111,
        "uuid": "82e986f7-9853-11ec-9985-f2fb1e710544",
        "name": "Jamaica",
        "country_code": "JM",
        "phone_code": "+1876",
        "image": "jm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 112,
        "uuid": "82e9874e-9853-11ec-9985-f2fb1e710544",
        "name": "Japan",
        "country_code": "JP",
        "phone_code": "+81",
        "image": "jp",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 113,
        "uuid": "82e987a4-9853-11ec-9985-f2fb1e710544",
        "name": "Jersey",
        "country_code": "JE",
        "phone_code": "+44",
        "image": "je",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 114,
        "uuid": "82e987fb-9853-11ec-9985-f2fb1e710544",
        "name": "Jordan",
        "country_code": "JO",
        "phone_code": "+962",
        "image": "jo",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 115,
        "uuid": "82e98852-9853-11ec-9985-f2fb1e710544",
        "name": "Kazakhstan",
        "country_code": "KZ",
        "phone_code": "+7",
        "image": "kz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 116,
        "uuid": "82e988a8-9853-11ec-9985-f2fb1e710544",
        "name": "Kenya",
        "country_code": "KE",
        "phone_code": "+254",
        "image": "ke",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 117,
        "uuid": "82e988fe-9853-11ec-9985-f2fb1e710544",
        "name": "Kiribati",
        "country_code": "KI",
        "phone_code": "+686",
        "image": "ki",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 118,
        "uuid": "82e98977-9853-11ec-9985-f2fb1e710544",
        "name": "Korea, Democratic People`s Republic of",
        "country_code": "KP",
        "phone_code": "+850",
        "image": "kp",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 119,
        "uuid": "82e989d1-9853-11ec-9985-f2fb1e710544",
        "name": "Korea, Republic of",
        "country_code": "KR",
        "phone_code": "+82",
        "image": "kr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 120,
        "uuid": "82e98a54-9853-11ec-9985-f2fb1e710544",
        "name": "Kosovo",
        "country_code": "XK",
        "phone_code": "+383",
        "image": "xk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 121,
        "uuid": "82e98aeb-9853-11ec-9985-f2fb1e710544",
        "name": "Kuwait",
        "country_code": "KW",
        "phone_code": "+965",
        "image": "kw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 122,
        "uuid": "82e98b46-9853-11ec-9985-f2fb1e710544",
        "name": "Kyrgyzstan",
        "country_code": "KG",
        "phone_code": "+996",
        "image": "kg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 123,
        "uuid": "82e98b9f-9853-11ec-9985-f2fb1e710544",
        "name": "Lao People`s Democratic Republic",
        "country_code": "LA",
        "phone_code": "+856",
        "image": "la",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 124,
        "uuid": "82e98bf6-9853-11ec-9985-f2fb1e710544",
        "name": "Latvia",
        "country_code": "LV",
        "phone_code": "+371",
        "image": "lv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 125,
        "uuid": "82e98c4e-9853-11ec-9985-f2fb1e710544",
        "name": "Lebanon",
        "country_code": "LB",
        "phone_code": "+961",
        "image": "lb",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 126,
        "uuid": "82e98ca5-9853-11ec-9985-f2fb1e710544",
        "name": "Lesotho",
        "country_code": "LS",
        "phone_code": "+266",
        "image": "ls",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 127,
        "uuid": "82e98cfc-9853-11ec-9985-f2fb1e710544",
        "name": "Liberia",
        "country_code": "LR",
        "phone_code": "+231",
        "image": "lr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 128,
        "uuid": "82e98d6a-9853-11ec-9985-f2fb1e710544",
        "name": "Libyan Arab Jamahiriya",
        "country_code": "LY",
        "phone_code": "+218",
        "image": "ly",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 129,
        "uuid": "82e98e20-9853-11ec-9985-f2fb1e710544",
        "name": "Liechtenstein",
        "country_code": "LI",
        "phone_code": "+423",
        "image": "li",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 130,
        "uuid": "82e98e9c-9853-11ec-9985-f2fb1e710544",
        "name": "Lithuania",
        "country_code": "LT",
        "phone_code": "+370",
        "image": "lt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 131,
        "uuid": "82e98ef4-9853-11ec-9985-f2fb1e710544",
        "name": "Luxembourg",
        "country_code": "LU",
        "phone_code": "+352",
        "image": "lu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 132,
        "uuid": "82e98f4b-9853-11ec-9985-f2fb1e710544",
        "name": "Macao",
        "country_code": "MO",
        "phone_code": "+853",
        "image": "mo",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 133,
        "uuid": "82e98fa2-9853-11ec-9985-f2fb1e710544",
        "name": "Macedonia, the Former Yugoslav Republic of",
        "country_code": "MK",
        "phone_code": "+389",
        "image": "mk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 134,
        "uuid": "82e98ffa-9853-11ec-9985-f2fb1e710544",
        "name": "Madagascar",
        "country_code": "MG",
        "phone_code": "+261",
        "image": "mg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 135,
        "uuid": "82e99051-9853-11ec-9985-f2fb1e710544",
        "name": "Malawi",
        "country_code": "MW",
        "phone_code": "+265",
        "image": "mw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 136,
        "uuid": "82e990a9-9853-11ec-9985-f2fb1e710544",
        "name": "Malaysia",
        "country_code": "MY",
        "phone_code": "+60",
        "image": "my",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 137,
        "uuid": "82e99100-9853-11ec-9985-f2fb1e710544",
        "name": "Maldives",
        "country_code": "MV",
        "phone_code": "+960",
        "image": "mv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 138,
        "uuid": "82e99157-9853-11ec-9985-f2fb1e710544",
        "name": "Mali",
        "country_code": "ML",
        "phone_code": "+223",
        "image": "ml",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 139,
        "uuid": "82e991ae-9853-11ec-9985-f2fb1e710544",
        "name": "Malta",
        "country_code": "MT",
        "phone_code": "+356",
        "image": "mt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 140,
        "uuid": "82e99204-9853-11ec-9985-f2fb1e710544",
        "name": "Marshall Islands",
        "country_code": "MH",
        "phone_code": "+692",
        "image": "mh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 141,
        "uuid": "82e9925a-9853-11ec-9985-f2fb1e710544",
        "name": "Martinique",
        "country_code": "MQ",
        "phone_code": "+596",
        "image": "mq",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 142,
        "uuid": "82e992b1-9853-11ec-9985-f2fb1e710544",
        "name": "Mauritania",
        "country_code": "MR",
        "phone_code": "+222",
        "image": "mr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 143,
        "uuid": "82e99308-9853-11ec-9985-f2fb1e710544",
        "name": "Mauritius",
        "country_code": "MU",
        "phone_code": "+230",
        "image": "mu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 144,
        "uuid": "82e9935f-9853-11ec-9985-f2fb1e710544",
        "name": "Mayotte",
        "country_code": "YT",
        "phone_code": "+269",
        "image": "yt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 145,
        "uuid": "82e993b5-9853-11ec-9985-f2fb1e710544",
        "name": "Mexico",
        "country_code": "MX",
        "phone_code": "+52",
        "image": "mx",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 146,
        "uuid": "82e9940b-9853-11ec-9985-f2fb1e710544",
        "name": "Micronesia, Federated States of",
        "country_code": "FM",
        "phone_code": "+691",
        "image": "fm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 147,
        "uuid": "82e99462-9853-11ec-9985-f2fb1e710544",
        "name": "Moldova, Republic of",
        "country_code": "MD",
        "phone_code": "+373",
        "image": "md",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 148,
        "uuid": "82e994b8-9853-11ec-9985-f2fb1e710544",
        "name": "Monaco",
        "country_code": "MC",
        "phone_code": "+377",
        "image": "mc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 149,
        "uuid": "82e9950f-9853-11ec-9985-f2fb1e710544",
        "name": "Mongolia",
        "country_code": "MN",
        "phone_code": "+976",
        "image": "mn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 150,
        "uuid": "82e99565-9853-11ec-9985-f2fb1e710544",
        "name": "Montenegro",
        "country_code": "ME",
        "phone_code": "+382",
        "image": "me",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 151,
        "uuid": "82e995bd-9853-11ec-9985-f2fb1e710544",
        "name": "Montserrat",
        "country_code": "MS",
        "phone_code": "+1664",
        "image": "ms",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 152,
        "uuid": "82e99613-9853-11ec-9985-f2fb1e710544",
        "name": "Morocco",
        "country_code": "MA",
        "phone_code": "+212",
        "image": "ma",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 153,
        "uuid": "82e9966a-9853-11ec-9985-f2fb1e710544",
        "name": "Mozambique",
        "country_code": "MZ",
        "phone_code": "+258",
        "image": "mz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 154,
        "uuid": "82e996c0-9853-11ec-9985-f2fb1e710544",
        "name": "Myanmar",
        "country_code": "MM",
        "phone_code": "+95",
        "image": "mm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 155,
        "uuid": "82e9977f-9853-11ec-9985-f2fb1e710544",
        "name": "Namibia",
        "country_code": "NA",
        "phone_code": "+264",
        "image": "na",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 156,
        "uuid": "82e997e4-9853-11ec-9985-f2fb1e710544",
        "name": "Nauru",
        "country_code": "NR",
        "phone_code": "+674",
        "image": "nr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 157,
        "uuid": "82e9983b-9853-11ec-9985-f2fb1e710544",
        "name": "Nepal",
        "country_code": "NP",
        "phone_code": "+977",
        "image": "np",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 158,
        "uuid": "82e99893-9853-11ec-9985-f2fb1e710544",
        "name": "Netherlands",
        "country_code": "NL",
        "phone_code": "+31",
        "image": "nl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 159,
        "uuid": "82e998ea-9853-11ec-9985-f2fb1e710544",
        "name": "Netherlands Antilles",
        "country_code": "AN",
        "phone_code": "+599",
        "image": "an",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 160,
        "uuid": "82e99942-9853-11ec-9985-f2fb1e710544",
        "name": "New Caledonia",
        "country_code": "NC",
        "phone_code": "+687",
        "image": "nc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 161,
        "uuid": "82e9999a-9853-11ec-9985-f2fb1e710544",
        "name": "New Zealand",
        "country_code": "NZ",
        "phone_code": "+64",
        "image": "nz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 162,
        "uuid": "82e999f1-9853-11ec-9985-f2fb1e710544",
        "name": "Nicaragua",
        "country_code": "NI",
        "phone_code": "+505",
        "image": "ni",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 163,
        "uuid": "82e99a47-9853-11ec-9985-f2fb1e710544",
        "name": "Niger",
        "country_code": "NE",
        "phone_code": "+227",
        "image": "ne",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 164,
        "uuid": "82e99a9e-9853-11ec-9985-f2fb1e710544",
        "name": "Nigeria",
        "country_code": "NG",
        "phone_code": "+234",
        "image": "ng",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 165,
        "uuid": "82e99af6-9853-11ec-9985-f2fb1e710544",
        "name": "Niue",
        "country_code": "NU",
        "phone_code": "+683",
        "image": "nu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 166,
        "uuid": "82e99b4d-9853-11ec-9985-f2fb1e710544",
        "name": "Norfolk Island",
        "country_code": "NF",
        "phone_code": "+672",
        "image": "nf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 167,
        "uuid": "82e99ba5-9853-11ec-9985-f2fb1e710544",
        "name": "Northern Mariana Islands",
        "country_code": "MP",
        "phone_code": "+1670",
        "image": "mp",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 168,
        "uuid": "82e99bff-9853-11ec-9985-f2fb1e710544",
        "name": "Norway",
        "country_code": "NO",
        "phone_code": "+47",
        "image": "no",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 169,
        "uuid": "82e99c56-9853-11ec-9985-f2fb1e710544",
        "name": "Oman",
        "country_code": "OM",
        "phone_code": "+968",
        "image": "om",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 170,
        "uuid": "82e99cac-9853-11ec-9985-f2fb1e710544",
        "name": "Pakistan",
        "country_code": "PK",
        "phone_code": "+92",
        "image": "pk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 171,
        "uuid": "82e99d03-9853-11ec-9985-f2fb1e710544",
        "name": "Palau",
        "country_code": "PW",
        "phone_code": "+680",
        "image": "pw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 172,
        "uuid": "82e99d5a-9853-11ec-9985-f2fb1e710544",
        "name": "Palestinian Territory, Occupied",
        "country_code": "PS",
        "phone_code": "+970",
        "image": "ps",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 173,
        "uuid": "82e99db1-9853-11ec-9985-f2fb1e710544",
        "name": "Panama",
        "country_code": "PA",
        "phone_code": "+507",
        "image": "pa",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 174,
        "uuid": "82e99e08-9853-11ec-9985-f2fb1e710544",
        "name": "Papua New Guinea",
        "country_code": "PG",
        "phone_code": "+675",
        "image": "pg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 175,
        "uuid": "82e99e5f-9853-11ec-9985-f2fb1e710544",
        "name": "Paraguay",
        "country_code": "PY",
        "phone_code": "+595",
        "image": "py",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 176,
        "uuid": "82e99eb5-9853-11ec-9985-f2fb1e710544",
        "name": "Peru",
        "country_code": "PE",
        "phone_code": "+51",
        "image": "pe",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 177,
        "uuid": "82e99f0c-9853-11ec-9985-f2fb1e710544",
        "name": "Philippines",
        "country_code": "PH",
        "phone_code": "+63",
        "image": "ph",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 178,
        "uuid": "82e99f63-9853-11ec-9985-f2fb1e710544",
        "name": "Pitcairn",
        "country_code": "PN",
        "phone_code": "0",
        "image": "pn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 179,
        "uuid": "82e99fba-9853-11ec-9985-f2fb1e710544",
        "name": "Poland",
        "country_code": "PL",
        "phone_code": "+48",
        "image": "pl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 180,
        "uuid": "82e9a010-9853-11ec-9985-f2fb1e710544",
        "name": "Portugal",
        "country_code": "PT",
        "phone_code": "+351",
        "image": "pt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 181,
        "uuid": "82e9a067-9853-11ec-9985-f2fb1e710544",
        "name": "Puerto Rico",
        "country_code": "PR",
        "phone_code": "+1787",
        "image": "pr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 182,
        "uuid": "82e9a0be-9853-11ec-9985-f2fb1e710544",
        "name": "Qatar",
        "country_code": "QA",
        "phone_code": "+974",
        "image": "qa",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 183,
        "uuid": "82e9a115-9853-11ec-9985-f2fb1e710544",
        "name": "Reunion",
        "country_code": "RE",
        "phone_code": "+262",
        "image": "re",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 184,
        "uuid": "82e9a16c-9853-11ec-9985-f2fb1e710544",
        "name": "Romania",
        "country_code": "RO",
        "phone_code": "+40",
        "image": "ro",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 185,
        "uuid": "82e9a1c3-9853-11ec-9985-f2fb1e710544",
        "name": "Russian Federation",
        "country_code": "RU",
        "phone_code": "+7",
        "image": "ru",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 186,
        "uuid": "82e9a21b-9853-11ec-9985-f2fb1e710544",
        "name": "Rwanda",
        "country_code": "RW",
        "phone_code": "+250",
        "image": "rw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 187,
        "uuid": "82e9a271-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Barthelemy",
        "country_code": "BL",
        "phone_code": "+590",
        "image": "bl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 188,
        "uuid": "82e9a2c9-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Helena",
        "country_code": "SH",
        "phone_code": "+290",
        "image": "sh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 189,
        "uuid": "82e9a322-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Kitts and Nevis",
        "country_code": "KN",
        "phone_code": "+1869",
        "image": "kn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 190,
        "uuid": "82e9a379-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Lucia",
        "country_code": "LC",
        "phone_code": "+1758",
        "image": "lc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 191,
        "uuid": "82e9a3d0-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Martin",
        "country_code": "MF",
        "phone_code": "+590",
        "image": "mf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 192,
        "uuid": "82e9a427-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Pierre and Miquelon",
        "country_code": "PM",
        "phone_code": "+508",
        "image": "pm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 193,
        "uuid": "82e9a47e-9853-11ec-9985-f2fb1e710544",
        "name": "Saint Vincent and the Grenadines",
        "country_code": "VC",
        "phone_code": "+1784",
        "image": "vc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 194,
        "uuid": "82e9a4d4-9853-11ec-9985-f2fb1e710544",
        "name": "Samoa",
        "country_code": "WS",
        "phone_code": "+684",
        "image": "ws",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 195,
        "uuid": "82e9a52c-9853-11ec-9985-f2fb1e710544",
        "name": "San Marino",
        "country_code": "SM",
        "phone_code": "+378",
        "image": "sm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 196,
        "uuid": "82e9a585-9853-11ec-9985-f2fb1e710544",
        "name": "Sao Tome and Principe",
        "country_code": "ST",
        "phone_code": "+239",
        "image": "st",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 197,
        "uuid": "82e9a5dc-9853-11ec-9985-f2fb1e710544",
        "name": "Saudi Arabia",
        "country_code": "SA",
        "phone_code": "+966",
        "image": "sa",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 198,
        "uuid": "82e9a634-9853-11ec-9985-f2fb1e710544",
        "name": "Senegal",
        "country_code": "SN",
        "phone_code": "+221",
        "image": "sn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 199,
        "uuid": "82e9a68c-9853-11ec-9985-f2fb1e710544",
        "name": "Serbia",
        "country_code": "RS",
        "phone_code": "+381",
        "image": "rs",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 200,
        "uuid": "82e9a6e3-9853-11ec-9985-f2fb1e710544",
        "name": "Serbia and Montenegro",
        "country_code": "CS",
        "phone_code": "+381",
        "image": "cs",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 201,
        "uuid": "82e9a75a-9853-11ec-9985-f2fb1e710544",
        "name": "Seychelles",
        "country_code": "SC",
        "phone_code": "+248",
        "image": "sc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 202,
        "uuid": "82e9a7b2-9853-11ec-9985-f2fb1e710544",
        "name": "Sierra Leone",
        "country_code": "SL",
        "phone_code": "+232",
        "image": "sl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 203,
        "uuid": "82e9a809-9853-11ec-9985-f2fb1e710544",
        "name": "Singapore",
        "country_code": "SG",
        "phone_code": "+65",
        "image": "sg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 204,
        "uuid": "82e9a862-9853-11ec-9985-f2fb1e710544",
        "name": "Sint Maarten",
        "country_code": "SX",
        "phone_code": "+1",
        "image": "sx",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 205,
        "uuid": "82e9a8b8-9853-11ec-9985-f2fb1e710544",
        "name": "Slovakia",
        "country_code": "SK",
        "phone_code": "+421",
        "image": "sk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 206,
        "uuid": "82e9a910-9853-11ec-9985-f2fb1e710544",
        "name": "Slovenia",
        "country_code": "SI",
        "phone_code": "+386",
        "image": "si",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 207,
        "uuid": "82e9a967-9853-11ec-9985-f2fb1e710544",
        "name": "Solomon Islands",
        "country_code": "SB",
        "phone_code": "+677",
        "image": "sb",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 208,
        "uuid": "82e9a9be-9853-11ec-9985-f2fb1e710544",
        "name": "Somalia",
        "country_code": "SO",
        "phone_code": "+252",
        "image": "so",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 209,
        "uuid": "82e9aa15-9853-11ec-9985-f2fb1e710544",
        "name": "South Africa",
        "country_code": "ZA",
        "phone_code": "+27",
        "image": "za",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 210,
        "uuid": "82e9aa6c-9853-11ec-9985-f2fb1e710544",
        "name": "South Georgia and the South Sandwich Islands",
        "country_code": "GS",
        "phone_code": "0",
        "image": "gs",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 211,
        "uuid": "82e9aac3-9853-11ec-9985-f2fb1e710544",
        "name": "South Sudan",
        "country_code": "SS",
        "phone_code": "+211",
        "image": "ss",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 212,
        "uuid": "82e9ab1a-9853-11ec-9985-f2fb1e710544",
        "name": "Spain",
        "country_code": "ES",
        "phone_code": "+34",
        "image": "es",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 213,
        "uuid": "82e9ab71-9853-11ec-9985-f2fb1e710544",
        "name": "Sri Lanka",
        "country_code": "LK",
        "phone_code": "+94",
        "image": "lk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 214,
        "uuid": "82e9abc8-9853-11ec-9985-f2fb1e710544",
        "name": "Sudan",
        "country_code": "SD",
        "phone_code": "+249",
        "image": "sd",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 215,
        "uuid": "82e9ac1e-9853-11ec-9985-f2fb1e710544",
        "name": "Suriname",
        "country_code": "SR",
        "phone_code": "+597",
        "image": "sr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 216,
        "uuid": "82e9ac75-9853-11ec-9985-f2fb1e710544",
        "name": "Svalbard and Jan Mayen",
        "country_code": "SJ",
        "phone_code": "+47",
        "image": "sj",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 217,
        "uuid": "82e9accc-9853-11ec-9985-f2fb1e710544",
        "name": "Swaziland",
        "country_code": "SZ",
        "phone_code": "+268",
        "image": "sz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 218,
        "uuid": "82e9ad22-9853-11ec-9985-f2fb1e710544",
        "name": "Sweden",
        "country_code": "SE",
        "phone_code": "+46",
        "image": "se",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 219,
        "uuid": "82e9ad79-9853-11ec-9985-f2fb1e710544",
        "name": "Switzerland",
        "country_code": "CH",
        "phone_code": "+41",
        "image": "ch",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 220,
        "uuid": "82e9add0-9853-11ec-9985-f2fb1e710544",
        "name": "Syrian Arab Republic",
        "country_code": "SY",
        "phone_code": "+963",
        "image": "sy",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 221,
        "uuid": "82e9ae28-9853-11ec-9985-f2fb1e710544",
        "name": "Taiwan, Province of China",
        "country_code": "TW",
        "phone_code": "+886",
        "image": "tw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 222,
        "uuid": "82e9ae7f-9853-11ec-9985-f2fb1e710544",
        "name": "Tajikistan",
        "country_code": "TJ",
        "phone_code": "+992",
        "image": "tj",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 223,
        "uuid": "82e9aed6-9853-11ec-9985-f2fb1e710544",
        "name": "Tanzania, United Republic of",
        "country_code": "TZ",
        "phone_code": "+255",
        "image": "tz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 224,
        "uuid": "82e9af2d-9853-11ec-9985-f2fb1e710544",
        "name": "Thailand",
        "country_code": "TH",
        "phone_code": "+66",
        "image": "th",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 225,
        "uuid": "82e9af84-9853-11ec-9985-f2fb1e710544",
        "name": "Timor-Leste",
        "country_code": "TL",
        "phone_code": "+670",
        "image": "tl",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 226,
        "uuid": "82e9afdb-9853-11ec-9985-f2fb1e710544",
        "name": "Togo",
        "country_code": "TG",
        "phone_code": "+228",
        "image": "tg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 227,
        "uuid": "82e9b031-9853-11ec-9985-f2fb1e710544",
        "name": "Tokelau",
        "country_code": "TK",
        "phone_code": "+690",
        "image": "tk",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 228,
        "uuid": "82e9b088-9853-11ec-9985-f2fb1e710544",
        "name": "Tonga",
        "country_code": "TO",
        "phone_code": "+676",
        "image": "to",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 229,
        "uuid": "82e9b0df-9853-11ec-9985-f2fb1e710544",
        "name": "Trinidad and Tobago",
        "country_code": "TT",
        "phone_code": "+1868",
        "image": "tt",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 230,
        "uuid": "82e9b137-9853-11ec-9985-f2fb1e710544",
        "name": "Tunisia",
        "country_code": "TN",
        "phone_code": "+216",
        "image": "tn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 231,
        "uuid": "82e9b18e-9853-11ec-9985-f2fb1e710544",
        "name": "Turkey",
        "country_code": "TR",
        "phone_code": "+90",
        "image": "tr",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 232,
        "uuid": "82e9b1e5-9853-11ec-9985-f2fb1e710544",
        "name": "Turkmenistan",
        "country_code": "TM",
        "phone_code": "+7370",
        "image": "tm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 233,
        "uuid": "82e9b23b-9853-11ec-9985-f2fb1e710544",
        "name": "Turks and Caicos Islands",
        "country_code": "TC",
        "phone_code": "+1649",
        "image": "tc",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 234,
        "uuid": "82e9b293-9853-11ec-9985-f2fb1e710544",
        "name": "Tuvalu",
        "country_code": "TV",
        "phone_code": "+688",
        "image": "tv",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 235,
        "uuid": "82e9b2ea-9853-11ec-9985-f2fb1e710544",
        "name": "Uganda",
        "country_code": "UG",
        "phone_code": "+256",
        "image": "ug",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 236,
        "uuid": "82e9b341-9853-11ec-9985-f2fb1e710544",
        "name": "Ukraine",
        "country_code": "UA",
        "phone_code": "+380",
        "image": "ua",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 237,
        "uuid": "82e9b398-9853-11ec-9985-f2fb1e710544",
        "name": "United Arab Emirates",
        "country_code": "AE",
        "phone_code": "+971",
        "image": "ae",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 238,
        "uuid": "82e9b3ee-9853-11ec-9985-f2fb1e710544",
        "name": "United Kingdom",
        "country_code": "GB",
        "phone_code": "+44",
        "image": "gb",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 239,
        "uuid": "82e9b445-9853-11ec-9985-f2fb1e710544",
        "name": "United States",
        "country_code": "US",
        "phone_code": "+1",
        "image": "us",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 240,
        "uuid": "82e9b49d-9853-11ec-9985-f2fb1e710544",
        "name": "United States Minor Outlying Islands",
        "country_code": "UM",
        "phone_code": "+1",
        "image": "um",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 241,
        "uuid": "82e9b4f5-9853-11ec-9985-f2fb1e710544",
        "name": "Uruguay",
        "country_code": "UY",
        "phone_code": "+598",
        "image": "uy",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 242,
        "uuid": "82e9b555-9853-11ec-9985-f2fb1e710544",
        "name": "Uzbekistan",
        "country_code": "UZ",
        "phone_code": "+998",
        "image": "uz",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 243,
        "uuid": "82e9b5cb-9853-11ec-9985-f2fb1e710544",
        "name": "Vanuatu",
        "country_code": "VU",
        "phone_code": "+678",
        "image": "vu",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 244,
        "uuid": "82e9b623-9853-11ec-9985-f2fb1e710544",
        "name": "Venezuela",
        "country_code": "VE",
        "phone_code": "+58",
        "image": "ve",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 245,
        "uuid": "82e9b67a-9853-11ec-9985-f2fb1e710544",
        "name": "Viet Nam",
        "country_code": "VN",
        "phone_code": "+84",
        "image": "vn",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 246,
        "uuid": "82e9b6d0-9853-11ec-9985-f2fb1e710544",
        "name": "Virgin Islands, British",
        "country_code": "VG",
        "phone_code": "+1284",
        "image": "vg",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 247,
        "uuid": "82e9b727-9853-11ec-9985-f2fb1e710544",
        "name": "Virgin Islands, U.s.",
        "country_code": "VI",
        "phone_code": "+1340",
        "image": "vi",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 248,
        "uuid": "82e9b77d-9853-11ec-9985-f2fb1e710544",
        "name": "Wallis and Futuna",
        "country_code": "WF",
        "phone_code": "+681",
        "image": "wf",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 249,
        "uuid": "82e9b7d4-9853-11ec-9985-f2fb1e710544",
        "name": "Western Sahara",
        "country_code": "EH",
        "phone_code": "+212",
        "image": "eh",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 250,
        "uuid": "82e9b82c-9853-11ec-9985-f2fb1e710544",
        "name": "Yemen",
        "country_code": "YE",
        "phone_code": "+967",
        "image": "ye",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 251,
        "uuid": "82e9b89d-9853-11ec-9985-f2fb1e710544",
        "name": "Zambia",
        "country_code": "ZM",
        "phone_code": "+260",
        "image": "zm",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    },
    {
        "id": 252,
        "uuid": "82e9b8f6-9853-11ec-9985-f2fb1e710544",
        "name": "Zimbabwe",
        "country_code": "ZW",
        "phone_code": "+263",
        "image": "zw",
        "created_at": "-000001-11-30T00:00:00.000000Z",
        "updated_at": null
    }
]

const PhoneNumberInput = (props: PropData) => {
    let textInput = React.createRef<HTMLInputElement>();
    const [options, setOptions] = useState<any[]>([]);
    const [selectedOption, setSelectedOption] = useState({ id: 130 });
    const [isFocus, setIsFocus] = useState(false);
    const [isOpenTop, setIsOpenTop] = useState(false);
    const [mobile, setMobile] = useState(props.value)
    let index = -1;
    const [selectedIndex, setSelectedIndex] = useState(index);
    const [search, setSearch] = useState("");
    const [userInput, setUserInput] = useState("");
 
    useEffect(() => {
        setOptions(allCountries.map((item: any, index: any) => {
 
            if (item.image && !item.image.toString().startsWith("/")) {
                item.image = `/assets/CountryFlagsIcon/${item.image}.svg`;
            }
            return { ...item }
        }));
    }, []);
 
    useEffect(() => {
        console.log("sed", props.selected)
        options?.map((value: any, i: number) => {
            if (value.phone_code === props.selected) {
                index = i;
                setSelectedOption(value)
                setSelectedIndex(index);
            }
        })
    }, [props.selected, options.length]);
 
    useEffect(() => {
        setMobile(props.value);
    }, [props.value]);
 
 
    const domNode = useClickOutside(() => {
        setIsFocus(false);
    });
 
    const checkPossition = () => {
        if (domNode.current) {
            var topHeight = domNode.current.getBoundingClientRect().y;
            var bottomHeight =
                window.innerHeight - domNode.current.getBoundingClientRect().y;
            if (bottomHeight > 300 || topHeight <= 280) {
                setIsOpenTop(false);
            } else {
                setIsOpenTop(true);
            }
        }
    };
 
    let searchOption: any[] = search
        ? options?.filter(function (option: any) {
            return option.name.toLowerCase().includes(search.toLowerCase());
        })
        : options;
 
    let optionsListComponent;
 
    if (searchOption?.length) {
        optionsListComponent = (
            <ul className={"options " + (isOpenTop ? "open-top" : "")}>
                {searchOption?.map((suggestion: any, index) => {
                    let className = "p-2";
                    if (index === selectedIndex) {
                        className = "option-active";
                    }
 
                    return (
                        <li className={className} style={{ height: 35 }} key={index} onMouseDown={() => onSelect(suggestion)}>
                            <img
                                src={suggestion.image}
                                width={20} alt="" className="me-2" />
                            <strong>{suggestion.name}</strong>
                            <span>{suggestion.phone_code}</span>
                        </li>
                    );
                })}
            </ul>
        );
    } else {
        optionsListComponent = (
            <div className="no-options">
                <em>No data found</em>
            </div>
        );
    };
 
    const onSelect = (e: any) => {
        setIsFocus(false);
        setSelectedOption(e.id);
        options?.map((value: any, i: number) => {
            if (value.id === e.id) {
                index = i;
                setSelectedOption(value)
                if (props.onChangeCode) {
                    props.onChangeCode(e);
                }
                handleKey(i)
                // if (props.onChangeCountryCode ) {
                //     props.onChangeCountryCode(e.country_code);
                // }
                setSelectedIndex(index);
            }
        });
    };
 
    const handleKey = (e: any) => {
        if (e.keyCode === 40) {
            if (selectedIndex < options.length - 1)
                setSelectedIndex(selectedIndex + 1);
        } else if (e.keyCode === 38) {
            if (selectedIndex > 0) setSelectedIndex(selectedIndex - 1);
        } else if (e.keyCode === 13) {
            options?.map((value: any, i: number) => {
                if (selectedIndex === i) {
                    onSelect(value);
                }
            });
        }
    };
 
    const checkOption = (enterValue: any) => {
        setIsFocus(false);
        var isFound = false;
        options?.map((value: any, i: number) => {
            if (value.id === enterValue || value.value === enterValue || value.phone_code === enterValue) {
                setUserInput(enterValue);
                handleKey(i);
                setSelectedOption(enterValue);
                onSelect(value);
                props.onChange(value);
                isFound = true;
                console.log(enterValue);
            }
        });
 
        if (enterValue && !isFound) {
            setUserInput(enterValue);
            setSelectedOption(enterValue);
            var temp: any = { id: enterValue, value: enterValue };
            onSelect(temp);
            props.onChange(temp);
        }
 
        setSearch("");
    };
 
    return (
        <>
            <Fragment>
                <div
                    // ref={domNode}
                    id={"selectId"}
                    className={"select w-100"}
                >
                    <div className="d-flex mb-2">
 
                        {
                            !isFocus ?
                                <div
                                    style={{ width: "20vh", height: '50px', borderTopRightRadius: '0 !important', borderBottomRightRadius: '0 !important' }}
                                    className={"form-style " + (isFocus ? "zindex" : "")}
                                    onKeyDown={(e) => {
                                        !props.isDisable && handleKey(e);
                                    }}
                                    onClick={() => {
                                        !props.isDisable && setIsFocus(!isFocus);
                                    }}
                                    tabIndex={0}
                                    onMouseDown={() => {
                                        if (!isFocus) {
                                            !props.isDisable && checkPossition();
                                        }
                                    }}
                                >
                                    <div className="form-control select-div text-truncate d-flex align-items-center border-end-1 rounded-end-1" style={{ height: 50, padding: 11 }}>
                                        {options?.map((item: any) => {
                                            return (
                                                <React.Fragment key={item.id}>
                                                    {(selectedOption?.id == item.id) && (
                                                        <>
                                                            <img
                                                                src={item.image}
                                                                width={20}
                                                                height={20}
                                                                alt="img"
                                                            />
                                                            {!isFocus && (
                                                                <svg id="img_downarrow" className="downarrow ms-1" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M3.34025 5.70127C3.30642 5.66831 3.16175 5.54386 3.04275 5.42793C2.29433 4.74828 1.06933 2.97526 0.695417 2.04727C0.635333 1.90634 0.508167 1.55003 0.5 1.35966C0.5 1.17724 0.542 1.00335 0.627167 0.837413C0.746167 0.630561 0.933417 0.464625 1.1545 0.373701C1.30792 0.315169 1.767 0.224245 1.77517 0.224245C2.27742 0.133321 3.0935 0.083313 3.99533 0.083313C4.85458 0.083313 5.63742 0.133321 6.14725 0.207765C6.15542 0.216289 6.72592 0.307213 6.92133 0.406661C7.27833 0.589077 7.5 0.945385 7.5 1.3267V1.35966C7.49125 1.60799 7.26958 2.13024 7.26142 2.13024C6.88692 3.00822 5.722 4.74032 4.94792 5.43645C4.94792 5.43645 4.749 5.63251 4.62475 5.71775C4.44625 5.85073 4.22517 5.91665 4.00408 5.91665C3.75733 5.91665 3.5275 5.8422 3.34025 5.70127Z" fill="#929295" />
                                                                </svg>
                                                            )}
                                                            <span>{item.phone_code}</span>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
 
 
                                    </div>
                                    {isFocus ? optionsListComponent : ""}
                                </div>
                                :
                                < div
                                    className={"form-control " + (isFocus ? "zindex" : "") + ' p-0'}
                                    tabIndex={0}
                                >
                                    <input
                                        ref={textInput}
                                        style={{ height: 50 }}
                                        className="form-control p-0 text-truncate rounded-end-0 border-end-0 country-code-inpute bg-white"
                                        placeholder="Search.."
                                        value={isFocus ? search : userInput}
                                        type="text"
                                        // onKeyPress={(e) =>
                                        //     props.max ? HelperService.maxNumber(e, props.max) : ""
                                        // }
                                        onBlur={(e) => { checkOption(e.target.value); props.onBlur && props.onBlur(e) }}
                                        onKeyDown={(e) => {
                                            handleKey(e);
                                        }}
                                        // onClick={() => {
                                        //     setIsFocus(!isFocus);
                                        // }}
                                        onMouseDown={() => {
                                            if (!props.isDisable) {
                                                if (!isFocus) {
                                                    checkPossition();
                                                }
                                                // setIsFocus(true);
                                            }
                                        }}
                                        disabled={props.isDisable}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                    {!isFocus ? (
                                        <div className="col-12 d-flex justify-content-end">
                                            down arrow
                                        </div>
                                    ) : (
                                        ""
                                    )}
 
                                    {isFocus ? optionsListComponent : ""}
                                </div>
                        }
 
                        <input
                            style={{ width: '130vh', height: '50px' }}
                            type="text"
                            disabled={props.isDisableInput}
                            value={mobile}
                            placeholder={props.placeholder ? props.placeholder : "Phone Number"}
                            // border-start-0
                            className="form-control rounded-start-0 bg-white"
                            onKeyPress={(e: any) => HelperService.allowOnlyNumericValue(e)}
                            maxLength={10}
                            // onKeyUp={(e) => HelperService.contactFormatter(e)}
                            onChange={(e: any) => { setMobile(e.target.value); props.onChange(e.target.value && e.target.value.replaceAll("-", "")) }}
                        />
                    </div>
                </div>
            </Fragment >
        </>
    );
};
 

export default PhoneNumberInput;